import React from 'react'
import styled from 'styled-components';
import LogoImage from '../../assets/eplusLogo.png'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const Footer = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language] || siteCopy.en;
  const { footer } = copy;

  return (
    <OuterContainer>
      <InnerLogoImage src={LogoImage} alt='로고'/>
      <InnerContainer>
        {footer.line1} &nbsp;&nbsp; | &nbsp;&nbsp; {footer.line2} &nbsp;&nbsp; | &nbsp;&nbsp; {footer.line3} <br/>
        {footer.line4}
      </InnerContainer>
      <InnerLogoImageMedia src={LogoImage} alt='로고'/>
    </OuterContainer>
  );
}

const OuterContainer = styled.div`
  width: 100%;
  height: 180px;
  background-color: ${props => props.theme.COLOR.BLACKPEARL};
  color: ${props => props.theme.COLOR.WHITE};
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: 400;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    flex-direction: column;
    height: 300px;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    flex-direction: column;
    height: 300px;
  }
`;

const InnerContainer = styled.div`
  width: 70%;
  height: 100%;
  align-content: center;
  line-height: 1.6;
  text-align: center;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    width: 90%;
    height: auto;
    padding: 20px 0 0;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    width: 90%;
    height: auto;
    padding: 20px 0 0;
    font-size: medium;
  }
`;

const InnerLogoImage = styled.img`
  width: 20%;
  height: 100%;
  object-fit: contain;
  border: 0px;
  transform: scale(0.5);

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`

const InnerLogoImageMedia = styled.img`
  display: none;
  width: 20%;
  height: auto;
  object-fit: contain;
  border: 0px;
  transform: scale(0.8);

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    padding-top: 20px;
    transform: scale(1);
    display: block;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    padding-top: 20px;
    transform: scale(1.5);
    display: block;
  }
`


export default Footer
